import { render } from "./add_branch_component.vue?vue&type=template&id=31a2cc6c&scoped=true"
import script from "./add_branch_component.vue?vue&type=script&lang=js"
export * from "./add_branch_component.vue?vue&type=script&lang=js"

import "./add_branch_component.vue?vue&type=style&index=0&id=31a2cc6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a2cc6c"]])

export default __exports__